// @flow

export const BASE_APP_URL = '/app/developer';

export const ZAPIER_APP_BASE_URL = process.env.ZAPIER_APP_BASE_URL || '';
export const PLATFORM_MARKETING_BASE_URL = `${ZAPIER_APP_BASE_URL}/platform`;
export const LEGACY_BUILDER_BASE_URL = `${ZAPIER_APP_BASE_URL}/developer/builder`; // legacy web-builder

// API URLs
export const ZAPIER_APP_API_PATH = '/api/platform/cli/apps';
export const ZAPIER_APP_V1_API_PATH = '/api/developer/v1';

// Documentation URLs
export const BASE_DOC_URL_VB = 'https://platform.zapier.com';
export const DOCUMENTATION_URL = `${ZAPIER_APP_BASE_URL}/developer/documentation/v2`;
export const DEVELOPER_CLI_GUIDE_URL = `${ZAPIER_APP_BASE_URL}/developer/start`;
